export default "__VITE_ASSET__BiNARR1F__";